import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { CSSProperties, ReactElement } from "react";
import styles from "./ActionListItem.module.less";
import { useIndention } from "./ActionListItem";

export type ActionListInfoProps = {
	text: string;
	isItalic?: boolean;
	trackingId?: string;
	indentionLevel?: number;
};

export const ActionListInfo = (props: ActionListInfoProps): ReactElement => {
	const {
		text,
		isItalic = false,
		trackingId,
		indentionLevel
	} = props;

	const style: CSSProperties = useIndention(indentionLevel);

	return (
		<li
			{...setTrackingId(trackingId)}
			className={styles.root}
			style={style}
		>
			<div className={styles.contentHost}>
				<span
					className={classNames(
						styles.text,
						{ [styles.text_italic]: isItalic }
					)}
				>
					{text}
				</span>
			</div>
		</li>
	);
};
ActionListInfo.displayName = "ActionListInfo";
